
import React, { useState, useEffect } from 'react'
import Select from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete } from 'react-icons/ai';
import { FaTimes } from 'react-icons/fa';
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import ToastNotification from '../../components/ToastNotification';


const Branches = () => {
    const [showForm, setShowForm] = useState(false);
    const [secondForm, setSecondForm] = useState(false);
    const [detail, setDetail] = useState([]);
    const [search, setSearch] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    const [companyOptions, setCompanyOptions] = useState([]); // dropdown options
    const [selectedCompany, setSelectedCompany] = useState(null); // selected company
    const [searchTerm, setSearchTerm] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [fetchCompany, setFetchCompany] = useState([])


    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });

    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };

    const [form, setForm] = useState({
        name: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        fax: '',
        pincode: '',
        code: '',
        remark: '',
        lbt_no: '',
        company_id: '',
        // head: null,
        // footer: null
    });


    const [files, setFiles] = useState({
        head: null,
        footer: null
    });



    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes → MB
            if (fileSizeInMB > 2) {
                showToast('File is too large please upload file less then 2 MB  !', 'danger');
                e.target.value = "";
                return; // stop here, don’t update state
            }

            setFiles((prevFiles) => ({
                ...prevFiles,
                [e.target.name]: file,
            }));
        }
        setFiles((prevFiles) => ({
            ...prevFiles,
            [e.target.name]: file,
        }));
    }



    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };




    const handleSubmit = async (e) => {
        e.preventDefault();


        if (isEditMode) {
            const data = new FormData();
            Object.keys(form).forEach((key) => {
                data.append(key, form[key]);
            });

            Object.keys(files).forEach((key) => {
                if (files[key]) data.append(key, files[key]);
            });

            try {
                await axios.put(
                    `https://api.skyguard.group/api/update-branch/${form.id}`, 
                    data,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );
                showToast('Branch updated successfully', 'success');

                fecthDetail();
                setShowForm(false);
                setForm({
                    name: '',
                    email: '',
                    phone: '',
                    address: '',
                    city: '',
                    state: '',
                    fax: '',
                    pincode: '',
                    code: '',
                    remark: '',
                    lbt_no: '',
                    company_id: '',
                    head: null,
                    footer: null
                })

            } catch (err) {
                console.error(err);
                showToast('Failed to update branch', 'danger');
            }

        } else {
            const formData = new FormData();

            // append text fields

            formData.append("name", form.name || '');
            formData.append("email", form.email || '');
            formData.append("phone", form.phone || '');
            formData.append("address", form.address || '');
            formData.append("city", form.city || '');
            formData.append("state", form.state || '');
            formData.append("fax", form.fax || '');
            formData.append("pincode", form.pincode || '');
            formData.append("code", form.code || '');
            formData.append("remark", form.remark || '');
            formData.append("lbt_no", form.lbt_no || '');
            formData.append("company_id", form.company_id || '');

            // append files
            Object.keys(files).forEach((key) => {
                if (files[key]) {
                    formData.append(key, files[key]);
                }
            });

            try {
                const res = await axios.post(
                    "https://api.skyguard.group/api/add-branch",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                showToast("Branch added successfully!", 'success');
                // fetchCompanies(); 
                fecthDetail();
                setShowForm(false);

                setForm({
                    name: '',
                    email: '',
                    phone: '',
                    address: '',
                    city: '',
                    state: '',
                    fax: '',
                    pincode: '',
                    code: '',
                    remark: '',
                    lbt_no: '',
                    company_id: '',
                    head: null,
                    footer: null
                })


            } catch (error) {
                console.error("❌ Error:", error.response?.data || error.message);
                showToast("Error adding company", 'danger');
            }

        }
    }

    const fecthDetail = async () => {
        try {
            const resBranch = await axios.get('https://api.skyguard.group/api/fetch-branch');

            setDetail(resBranch.data.result);
        } catch (error) {
            console.log(error)
        }
    };


    const fecthCompanyDetail = async () => {
        try {
            const resDetail = await axios.get('https://api.skyguard.group/api/fetch-detail');

            setFetchCompany(resDetail.data.result);
        } catch (error) {
            console.log(error)
        }
    };

    useEffect(() => {
        fecthDetail();
        fecthCompanyDetail();
    }, []);





    const handleEdit = (form) => {

        setForm({
            id: form.id || '',
            name: form.name || '',
            email: form.email || '',
            phone: form.phone || '',
            address: form.address || '',
            city: form.city || '',
            state: form.state || '',
            fax: form.fax || '',
            pincode: form.pincode || '',
            code: form.code || '',
            remark: form.remark || '',
            lbt_no: form.lbt_no || '',
            company_id: form.company_id || '',

        });


        setFiles({
            head: form.header_img || null,
            footer: form.footer_img || null
        });

        setEditingCompanyId(form.id);
        setIsEditMode(true);
        setShowForm(true);
    };




    const handleDelete = async (id) => {


        try {
            const deleteCompany = await axios.delete(`https://api.skyguard.group/api/delete-branch/${id}`);

            setDetail((prev) => prev.filter((com) => com.id !== id));
            showToast("Branch deleted successfully!", 'success');
            fecthDetail();

        } catch (err) {
            console.error("Error deleting company:", err);
            showToast("Failed to delete branch", 'danger');
        }
    };



    const handleDeleteClick = (id) => {
        setDeleteId(id);        // save which branch we want to delete
        setShowConfirm(true);   // open popup
    };

    const confirmDelete = () => {
        if (deleteId) {
            handleDelete(deleteId);  // ✅ now we have the branch id
            setShowConfirm(false);
            setDeleteId(null);       // reset
        }
    };


    const filterBranch = detail.filter((tt) => {
        const term = searchTerm.toLowerCase();

        return (
            (tt.code && tt.code.toLowerCase().includes(term)) ||
            (tt.name && tt.name.toString().toLowerCase().includes(term)) ||
            (tt.phone && tt.phone.toString().toLowerCase().includes(term))
        );
    });


    return (
        <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />
                <h3 className='my-3 fw-bold fs-5 golos'>Branches</h3>

                <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">

                    <div className="mb-2 w-50 w-md-50 pe-md-2">
                        <input className="form-control w-100" list="datalistOptions" id="exampleDataList" placeholder="Search by Branch Name ,Code,Phone"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>

                    <div className="mb-2">
                        <button
                            className={`btn ${showForm ? 'btn-danger' : 'btn-success'}`}
                            onClick={() => {
                                setShowForm(!showForm);

                            }}
                        >
                            {showForm ? (
                                <>
                                    Close <FaTimes size={20} />
                                </>
                            ) : (
                                <>
                                    Add Branch  <AiOutlinePlusCircle size={22} />
                                </>
                            )}
                        </button>
                    </div>
                </div>


                {showForm && (

                    <div className='card p-3 mb-3'>
                        <form onSubmit={handleSubmit} >

                            <h5 className="mt-3 ">Basic Info</h5>
                       {isEditMode && (
  <div className="mb-3">
    <label>Branch Name:</label> <br />
    <span className="badge bg-primary px-3 py-2">
     {form.name}
    </span>
  </div>
)}
                            <hr />

                            <div className='row g-3'>
                                <div className="col-md-4">
                                    <label>Branch Name </label>
                                    <input type="text" className="form-control" name="name" placeholder=" Branch Name" value={form.name} onChange={handleInputChange} required />
                                </div>

                                <div className="col-md-4">
                                    <label>Branch Code</label>
                                    <input type="text" className="form-control" name="code" placeholder="Branch Code " value={form.code} onChange={handleInputChange} />
                                </div>

                                <div className="col-md-4">
                                    <label>Company </label>
                                    {/* <input type="text" className="form-control" name="company" placeholder="Compnay Name" value={form.company} onChange={handleInputChange} /> 
                                        */}
                                    <select
                                        className="form-control"
                                        name="company_id"
                                        value={form.company_id}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select Company</option>

                                        {fetchCompany.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <label>Email </label>
                                    <input type="email" className="form-control" name="email" placeholder="Email" value={form.email} onChange={handleInputChange} required />
                                </div>
                                <div className="col-md-4">
                                    <label>Phone </label>
                                    <input type="number" className="form-control" name="phone" placeholder="Phone No" value={form.phone} onChange={handleInputChange} maxLength={10} required />
                                </div>

                                <div className="col-md-4">
                                    <label>Address </label>
                                    <input type="text" className="form-control" name="address" placeholder="Address" value={form.address} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <label>City </label>
                                    <input type="text" className="form-control" name="city" placeholder="City" value={form.city} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <label>State </label>
                                    <input type="text" className="form-control" name="state" placeholder="State" value={form.state} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <label>Pincode </label>
                                    <input type="text" className="form-control" name="pincode" placeholder="Pincode" value={form.pincode} onChange={handleInputChange} />
                                </div>

                                <h5 className="mt-4">Other Details</h5>
                                <hr />
                                <div className="row g-3">

                                    <div className="col-md-4">
                                        <label>Remark </label>
                                        <input type="text" className="form-control" name="remark" placeholder="Remark" value={form.remark} onChange={handleInputChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <label>Fax </label>
                                        <input type="text" className="form-control" name="fax" placeholder="Fax" value={form.fax} onChange={handleInputChange} />
                                    </div>



                                    <div className="col-md-4">
                                        <label>LBT No. </label>
                                        <input type="text" className="form-control" name="lbt_no" placeholder="LBT No." value={form.lbt_no} onChange={handleInputChange} />
                                    </div>


                                    <div className="col-md-4">
                                        <label className="form-label" >Letter Head</label>
                                        {isEditMode && files.head && typeof files.head === "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.head}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.head}
                                                </a>
                                            </div>
                                        )}




                                        <input type="file" className="form-control   " name="head_img" accept="image/*,application/pdf" onChange={handleFileChange} />

                                    </div>

                                    <div className="col-md-4">
                                        <label className="form-label" > Letter Head Footer</label>
                                        {isEditMode && files.footer && typeof files.footer === "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.footer}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.footer}
                                                </a>
                                            </div>
                                        )}

                                        <input type="file" className="form-control" name="footer_img" accept="image/*,application/pdf" onChange={handleFileChange} />
                                    </div>


                                </div>


                                <div className="col-md-12 text-end">
                                    {/* <button className='btn btn-primary' type='submit' >
                                        Submit
                                    </button> */}
                                    <button type="submit" className='btn btn-success w-10'>
                                        {isEditMode ? "Update" : "Save"}
                                    </button>
                                    <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                        setShowForm(false);
                                        setIsEditMode(false);
                                        setForm({
                                            name: '',
                                            email: '',
                                            phone: '',
                                            address: '',
                                            city: '',
                                            state: '',
                                            fax: '',
                                            pincode: '',
                                            code: '',
                                            remark: '',
                                            lbt_no: '',
                                            company: '',
                                            head: null,
                                            footer: null
                                        })

                                    }}

                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>
                )}

                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    <table className='table table-bordered table-striped table-hover text-center align-middle'>
                        <thead className='table-info'>
                            <tr>
                                  <th scope='col'>Action</th>
                                <th scope='col'>Branch Name</th>
                                <th scope='col'>Branch Code</th>
                                <th scope='col'>Company Name</th>

                                <th scope='col'>Phone No</th>
                              
                            </tr>
                        </thead>
                        <tbody>


                            {filterBranch.length > 0 ? (filterBranch.map
                                ((branch, idx) => (
                                    <tr key={idx}>
                                        {/* <td>{idx + 1}</td> */}
                                        
                                        <td>
                                            <button
                                                className="btn btn-primary"
                                                onClick={() => handleEdit(branch)}
                                            >
                                                Edit
                                            </button>
                                            &nbsp;
                                            <button
                                                className="btn btn-danger"
                                                onClick={() => handleDeleteClick(branch.id)}
                                            >
                                                <AiOutlineDelete size={20} />
                                            </button>
                                        </td>

                                        <td>{branch.name}</td>
                                        <td>{branch.code}</td>
                                        <td>{branch.company_name}</td>

                                        <td>{branch.phone}</td>

                                    </tr>
                                )
                                )) : (
                                <tr>
                                    <td colSpan="7">No data found.</td>
                                </tr>
                            )
                            }


                        </tbody>
                        {showConfirm && (
                            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                <div className="modal-dialog modal-sm" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Confirm Delete</h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                onClick={() => setShowConfirm(false)}
                                            ></button>
                                        </div>
                                        <div className="modal-body">
                                            <p>Are you sure you want to delete this branch?</p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={() => setShowConfirm(false)}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={confirmDelete}  // ✅ will call handleDelete(deleteId)
                                            >
                                                OK
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Branches;


